import React from "react";

// compoennts
import Navbar from "./navbar/Navbar";
import Footer from "./footer";
import FloatingChat from "../../components/ui/FloatingChat/FloatingChat";
import { useLocation } from "react-router-dom";

type IGuestTheme = {
  children: React.ReactNode;
};

const GuestTheme: React.FC<IGuestTheme> = ({ children }) => {
  const location = useLocation();
  const isHidden =
    location.pathname === "/login" || location.pathname === "/register";
  return (
    <div className="grid w-full">
      <Navbar isHidden={isHidden} />
      <section>{children}</section>
      <Footer isHidden={isHidden} />
      <FloatingChat isHidden={isHidden} />
    </div>
  );
};

export default GuestTheme;
